/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text } from 'hocs/localization'
import Modal, { ModalMessage, ModalFooter, ModalFooterButtons } from 'apps/Modal'
import Button from 'elements/Button'
import { toCurrency } from 'utils/price'
import { MODAL_CONFIRM_CHANGING_PLAN } from './constants'

interface IProps {
  t: Text,
  onClose: () => void,
  goToPlans: () => void,
  upCharged: string,
  downCharged: string,
}

const ConfirmChangingPlanModal: React.SFC<IProps> = ({
 t,
 onClose,
 upCharged,
 downCharged,
 goToPlans,
}) => (
  <Modal name={MODAL_CONFIRM_CHANGING_PLAN} shouldCloseOnOverlayClick>
    <ModalMessage>
      {t('youWillBeCharged', {
        upCharged: toCurrency(upCharged),
        downCharged: toCurrency(downCharged),
      })}
    </ModalMessage>
    <ModalFooter>
      <ModalFooterButtons>
        <Button onClick={goToPlans}>
          {t('yes')}
        </Button>
        <Button onClick={onClose} styleType='red'>
          {t('no')}
        </Button>
      </ModalFooterButtons>
    </ModalFooter>
  </Modal>
)

export default ConfirmChangingPlanModal
